var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInvoicesSkeletonMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 335 1047"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "url(#invoices-skeleton-mobile_svg__b)",
  clipPath: "url(#invoices-skeleton-mobile_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 50,
  rx: 25
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 50,
  y: 74,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 229,
  y: 170,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 95,
  height: 44,
  x: 120,
  y: 1003,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 24,
  x: 255,
  y: 1013,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 24,
  y: 1013,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 39.273,
  y: 431,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 39.273,
  y: 480.273,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 39.273,
  y: 529.545,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 39.273,
  y: 578.818,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 39.273,
  y: 628.091,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 39.273,
  y: 677.364,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 39.273,
  y: 726.636,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 39.273,
  y: 775.909,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 39.273,
  y: 825.182,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 39.273,
  y: 874.455,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 39.273,
  y: 923.728,
  rx: 5
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "invoices-skeleton-mobile_svg__b",
  x1: 0,
  x2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "stop-color",
  dur: "1s",
  repeatCount: "indefinite",
  values: "white; #F7F7F7; white;"
})), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7F7F7"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "stop-color",
  dur: "1s",
  repeatCount: "indefinite",
  values: "#F7F7F7; white; #F7F7F7;"
})), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "gradientTransform",
  dur: "3s",
  from: "0 0 0",
  repeatCount: "indefinite",
  to: "0 0 0",
  type: "translate"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "invoices-skeleton-mobile_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h335v1047H0z"
})))));
export { SvgInvoicesSkeletonMobile as ReactComponent };
export default __webpack_public_path__ + "static/media/invoices-skeleton-mobile.8f92a5f8ddc4bc499a6b.svg";